import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Card, CardContent } from '@workspace/shadcn';

export function AuthShell({
  title,
  subtitle,
  backTo,
  backLabel = 'Back',
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  backTo?: string;
  backLabel?: string;
  children: ReactNode;
}) {
  return (
    <main className="bg-muted/40 flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 flex justify-center">
          <img src="/images/logo.png" alt="ITGL Academy" className="h-24" />
        </Link>

        <Card>
          <CardContent className="p-6 sm:p-8">
            {backTo && (
              <Link
                to={backTo}
                className="text-muted-foreground hover:text-foreground mb-4 inline-flex items-center gap-1 text-sm"
              >
                <ArrowLeft className="size-4" />
                {backLabel}
              </Link>
            )}

            <h1 className="text-2xl font-bold">{title}</h1>
            {subtitle && (
              <div className="text-muted-foreground mt-1 text-sm">
                {subtitle}
              </div>
            )}

            {children}
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
